import { Injectable, PLATFORM_ID, inject, signal } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

const DARK_MODE_KEY = 'portal.dark-mode';

@Injectable({ providedIn: 'root' })
export class PortalDarkModeService {
  private readonly platformId = inject(PLATFORM_ID);
  readonly isDark = signal(false);

  constructor() {
    if (isPlatformBrowser(this.platformId)) {
      const stored = localStorage.getItem(DARK_MODE_KEY);
      const isDark = stored === 'true';
      this.isDark.set(isDark);
      this.applyClass(isDark);
    }
  }

  toggle(): void {
    const next = !this.isDark();
    this.isDark.set(next);
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem(DARK_MODE_KEY, String(next));
      this.applyClass(next);
    }
  }

  private applyClass(isDark: boolean): void {
    if (isDark) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }
}
